/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Ui_Lap_LabelInputs */

const en_ui_lap_label = /** @type {(inputs: Ui_Lap_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lap ${i?.number}`)
};

const de_ui_lap_label = /** @type {(inputs: Ui_Lap_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Runde ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Lap {number}" |
*
* @param {Ui_Lap_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_lap_label = /** @type {((inputs: Ui_Lap_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Lap_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_lap_label(inputs)
	return de_ui_lap_label(inputs)
});